module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAApUlEQVR4AczRsQrDIBAGYK9toG/UMWPWIBmy+mS3ZgquGTP2jQqhd/Wgg5Q7TckSQVHh/47Tizs4TgrEwI85bO2e7tQWyLm7Y4gxbF0NUQGPsBJcR2KYaogKSNUBYdmDmMAvYr1JERDkJkthFoH0Gx3xeyLg0WOzao4J5OEBm0ULy50KzIFb+lYuhU0gqS8H3NfCJtAjPL3Rs4TymYrlx//3h4EPAAAA//+BbBGYAAAABklEQVQDAHcBRyGyGVDgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1.png
// module id = fgq6
// module chunks = 20